import {PatchUpdateEmailParams} from 'domain/usecases';
import {makePatchUpdateEmail} from 'main/factories/usecases';

export async function patchUpdateEmail(params: PatchUpdateEmailParams) {
	await makePatchUpdateEmail().patch(params);

	return params;
}
